import { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/TextLayer.css";
import "react-pdf/dist/Page/AnnotationLayer.css";

import { LoadingSpinner } from "@/components/ui/LoadingSpinner";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
	"pdfjs-dist/build/pdf.worker.min.mjs",
	import.meta.url,
).toString();

interface PdfViewerProps {
	url: string;
	title?: string;
	className?: string;
	pageWidth?: number;
}

export const PdfViewer: React.FC<PdfViewerProps> = ({
	url,
	title,
	className,
	pageWidth,
}) => {
	const [numPages, setNumPages] = useState(0);
	const [error, setError] = useState(false);

	if (error) {
		return (
			<div className="flex flex-col items-center justify-center h-full text-text-tertiary gap-2">
				<span className="text-sm">No se pudo cargar el documento</span>
			</div>
		);
	}

	return (
		<div
			className={className ?? "w-full h-full overflow-auto"}
			aria-label={title}
		>
			<Document
				file={url}
				onLoadSuccess={({ numPages: n }) => setNumPages(n)}
				onLoadError={() => setError(true)}
				loading={
					<div className="flex items-center justify-center h-full min-h-40">
						<LoadingSpinner size="md" variant="subtle" />
					</div>
				}
			>
				{Array.from({ length: numPages }, (_, i) => (
					<div
						key={i + 1}
						className="bg-white shadow-md mb-4 last:mb-0 mx-auto w-fit"
					>
						<Page
							pageNumber={i + 1}
							width={pageWidth}
							className={
								pageWidth ? undefined : "[&_canvas]:!w-full [&_canvas]:!h-auto"
							}
						/>
					</div>
				))}
			</Document>
		</div>
	);
};
